import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hr-report-list',
  templateUrl: './hr-report-list.component.html',
  styleUrls: ['./hr-report-list.component.css']
})
export class HrReportListComponent implements OnInit {

  menuList: any;
  allowedComponents = new Set<string>();

  constructor(private router:Router) { }

  ngOnInit(): void {
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
    menu.menu?.menuComponents?.forEach(component => {
      this.allowedComponents.add(component.name);
    });
  });
  }

  hasAccess(componentName: string): boolean {
  return this.allowedComponents.has(componentName);
}

  diaryDetailsClick(){
    this.router.navigate(['dashboard/diary-details']);
  }
  penaltySummaryClick(){
    this.router.navigate(['dashboard/penalty-summary-report']);
  }
  articleAvailabilityClick(){
    this.router.navigate(['dashboard/article-availability-report']);
  }
  articleOneSixthClick(){
    this.router.navigate(['dashboard/article-one-sixth-report']);
  }
  employeeLeaveSummaryClick(){
    this.router.navigate(['dashboard/hr-my-leaves']);
  }
  empanelmentReportClick(){
    this.router.navigate(['dashboard/empanelment-report']);
  }
  overtimeReportClick(){
    this.router.navigate(['dashboard/overtime-report']);
  }
  articleDebitCreditReportClick(){
    this.router.navigate(['dashboard/article-debit-credit-hours']);
  }
  salarySlipClick(){
    this.router.navigate(['dashboard/salary-slip']);
  }
  assetPhysicalVerificationClick(){
    this.router.navigate(['dashboard/physical-verification-report']);
  }
  assetpopupconfirmationClick(){
    this.router.navigate(['dashboard/popup-confirmation-report']);
  }
  assetHistoryClick(){
    this.router.navigate(['dashboard/transfer-history-report']);
  }
  manageAnnouncementClick(){
    this.router.navigate(['dashboard/manage-announcement-history']);
  }
  manageMonthlyNewJoineeClick()
  {
    this.router.navigate(['dashboard/monthly-new-joinee-report']);
  }
  manageEmployeeLeftReportClick(){
    this.router.navigate(['dashboard/monthly-left-employee-report']);
  }
  monthlyConveyanceDetailsClick(){
    this.router.navigate(['dashboard/monthly-conveyance-detail-report'])
  }
   exitFormSummaryClick(){
    this.router.navigate(['/dashboard/exit-form-summary'])
  }
  latestCtcDetailsReportClick(){
    this.router.navigate(['/dashboard/latest-ctc-details-report'])
  }
  latestReportingPartnersClick(){
    this.router.navigate(['/dashboard/latest-reporting-partners'])
  }
}
